// What the tenant's hardware lets it do, derived from data rather than from a per-tenant flag,
// so a feature reappears on its own if hardware is added.
//
// Five modules ask this question: Navigation (both nav surfaces render from one filtered list),
// App's route table, Configuration's hardware tabs, System Reports' cellular rail, and Home's
// summary rows. The rule lives here so they cannot disagree — a nav filter that says "no Map"
// while the router still serves /Map is not a control, it is decoration, and four separate
// copies of `!== 0` is how the two drift apart in the first place.

// Strictly `!== 0`, because null and undefined mean "not known" rather than "none". That is NOT
// only the brief window before the first poll: usePolledResource holds `data` null until a poll
// SUCCEEDS, so an account whose poll is durably denied (401/403) sits at an unknown count
// indefinitely. Both cases fail OPEN, deliberately - a denied account already sees the "Data
// unavailable" notice, and taking its screens away too would hide working screens without
// protecting anything.
export const hasSatellites = (satelliteCount) => satelliteCount !== 0;
